export default {
  data() {
    return {
      tempSerialItem: []
    };
  },
  methods: {
    checkMove(e) {
      console.log(e, "move");
    },
    startDrag(e) {
      this.draggableSort = true;
      this.tempSerialItem = this.serialItem;
      console.log(e, "start drag");
      console.log(this.tempSerialItem, "start drag item");
      console.log(this.correctTips, "Correct");
      console.log(this.correctChecked, "Correct");
    },
    removeMoves(e) {
      console.log(e, "end drag");
      console.log(this.tempSerialItem, "end drag item");

      let tempOld = this.tempSerialItem[e.oldIndex];
      let tempNew = this.tempSerialItem[e.newIndex];

      let temp = this.tempSerialItem;

      temp[e.oldIndex] = tempNew;
      temp[e.newIndex] = tempOld;

      console.log(temp, "改变之后的值");

      temp.forEach((item, i) => {
        item.number = String.fromCharCode(i + 65);
      });
      this.serialItem = temp;
      const successNumbers = temp.filter(item => item.successState).map(item => item.number);
      this.correctTips = successNumbers[0];
      this.correctChecked = successNumbers;
      this.$forceUpdate();
    },
  },
};
